import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
export function FloatingBuyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
      setIsVisible(scrollPercent >= 20);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <a href="https://www.voicesoffreedomus.com/cart/45295821488314:1" className={`fixed bottom-20 right-4 md:bottom-8 md:right-8 z-50 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-90 pointer-events-none'}`} data-id="element-57">
      <style data-id="element-58">
        {`
          @keyframes buyPulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.7); }
            50% { box-shadow: 0 0 0 12px rgba(250, 204, 21, 0); }
          }
          .buy-pulse {
            animation: buyPulse 1.5s ease-in-out infinite;
          }
        `}
      </style>
      <div className="buy-pulse bg-yellow-400 hover:bg-yellow-300 text-red-600 font-extrabold px-5 py-3.5 md:px-7 md:py-4 rounded-full shadow-2xl flex items-center gap-2 md:gap-3 transition-colors" data-id="element-59">
        <ZapIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-60" />
        <span className="text-sm md:text-base tracking-wide whitespace-nowrap" data-id="element-61">
          ¡COMPRAR $17!
        </span>
      </div>
    </a>;
}